'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var React = require('react');
var stringify = require('json-stringify-pretty-compact');

function isDefaultProp(defaultProps, key, value) {
  if (!defaultProps) {
    return false;
  }
  return defaultProps[key] === value;
}

function stringedObject(object, opts) {
  var result;
  if (Array.isArray(object)) {
    result = object.map(function (item) {
      return stringedObject(item);
    });
  } else if (object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object') {
    result = {};
    Object.keys(object).map(function (key) {
      var value = object[key];
      if (React.isValidElement(value)) {
        value = jsxToString(value, opts);
      } else if (Array.isArray(value)) {
        value = value.map(function (item) {
          return stringedObject(item, opts);
        });
      } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        value = stringedObject(value, opts);
      } else if (typeof value === 'function') {
        value = '...';
      }
      result[key] = value;
    });
  } else {
    result = object;
  }
  return result;
}

var _JSX_REGEXP = /"<.+>"/g;

function jsxToString(component, options) {

  var baseOpts = {
    displayName: component.type.displayName || component.type.name || component.type,
    ignoreProps: [],
    keyValueOverride: {},
    spacing: 0
  };

  var opts = _extends({}, baseOpts, options);

  var componentData = {
    name: opts.displayName
  };

  delete opts.displayName;

  if (component.props) {
    componentData.props = Object.keys(component.props).map(function (key) {
      if (key === 'children' || isDefaultProp(component.type.defaultProps, key, component.props[key]) || opts.ignoreProps.indexOf(key) > -1) {
        return '';
      } else {
        var value = component.props[key];
        if (typeof value === 'string') {
          return ' ' + key + '="' + value + '"';
        } else if (React.isValidElement(value)) {
          value = jsxToString(value, opts);
        } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
          value = stringify(stringedObject(value, opts));
          // remove string quotes from embeded JSX values
          value = value.replace(_JSX_REGEXP, function (match) {
            return match.slice(1, match.length - 1);
          });
        } else if (typeof value === 'function') {
          value = '...';
        }
        return ' ' + key + '={' + (opts.keyValueOverride[key] || value) + '}';
      }
    }).join('');
  }

  if (component.props.children) {
    opts.spacing += 2;
    var indentation = new Array(opts.spacing + 1).join(' ');
    if (typeof component.props.children === 'string') {
      componentData.children = component.props.children;
    } else if (_typeof(component.props.children) === 'object' && !Array.isArray(component.props.children)) {
      componentData.children = jsxToString(component.props.children, opts);
    } else {
      componentData.children = component.props.children.filter(function (child) {
        return child;
      }).map(function (child) {
        return typeof child === 'string' ? child : jsxToString(child, opts);
      }).join('\n' + indentation);
    }
    return '<' + componentData.name + componentData.props + '>\n' + indentation + componentData.children + '\n' + indentation.slice(0, -2) + '</' + componentData.name + '>';
  } else {
    return '<' + componentData.name + componentData.props + ' />';
  }
}

exports.default = jsxToString;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/jsx-to-string/lib/index.js
 ** module id = 378
 ** module chunks = 0
 **/